import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class PageScrollLockService {
  private readonly lockSubject = new BehaviorSubject(false);

  readonly lock$ = this.lockSubject.asObservable();

  lock(): void {
    this.lockSubject.next(true);
  }

  unlock(): void {
    this.lockSubject.next(false);
  }
}
